import { DropdownModule } from 'primeng/dropdown';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MeetingState, MeetingStateDescriptions } from '../../../models/enums/enums';
import { ScheduledCallsForMentorRequest } from '../../../models/calendly/scheduledCallsForMentorRequest';
@Component({
  selector: 'app-meeting-filters',
  standalone: true,
  imports: [CalendarModule,CommonModule,DropdownModule,ReactiveFormsModule],
  templateUrl: './meeting-filters.component.html',
  styleUrl: './meeting-filters.component.scss'
})
export class MeetingFiltersComponent {
  filterForm!: FormGroup;

  @Input() isSearching: boolean = false;
  @Output() onSearch = new EventEmitter();
  statuses = [
      { name: MeetingStateDescriptions[MeetingState.Active], value: 1 },
      { name: MeetingStateDescriptions[MeetingState.Canceled], value: 2 }
    ];
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.filterForm = this.fb.group({
      fromDate: [null],
      toDate: [null],
      status: [MeetingState.Active]
    });
  }

  Search() {
    let formValues = { ...this.filterForm.value };

    if (formValues.fromDate) {
      formValues.fromDate = this.adjustForTimezone(formValues.fromDate);
    }
    
    if (formValues.toDate) {
      formValues.toDate = this.adjustForTimezone(formValues.toDate);
    } 

    let request:ScheduledCallsForMentorRequest={
      startDate: formValues.fromDate,
      endDate: formValues.toDate,
      meetingStatus: formValues.status,
      pageNumber: 1,
      pageSize: 10
    }
    this.onSearch.emit(request);
  }

  adjustForTimezone(date: string | Date): string {
    let dt = new Date(date);
    let timezoneOffset = dt.getTimezoneOffset(); // Offset in minutes
  
    // Adjust the date by adding the offset (because offset is negative for UTC+ timezones)
    dt.setMinutes(dt.getMinutes() - timezoneOffset);
  
    return dt.toISOString(); // Convert to UTC before sending
  }
  
}
